import { useSelector } from 'react-redux';

import {
  selectHasOptions,
  selectOptionsBreakdown,
  selectSelectedOptionsTotal,
  selectTotalPrice,
} from 'src/redux/basket/selectors';
import {
  selectIsInStock,
  selectIsPersonalisable,
  selectProductPrice,
} from 'src/redux/product/selectors';
import type { PriceBreakdownStateProps } from './PriceBreakdown';

/**
 * Null when there is no breakdown to show: either the product has no options to
 * price up, or it is out of stock and so cannot be bought at any price. Both
 * gates live here rather than in the caller so the "is there a total" question
 * has a single answer, whichever surface is asking.
 */
export const usePriceBreakdown = (): PriceBreakdownStateProps | null => {
  const hasOptions = useSelector(selectHasOptions);
  const inStock = useSelector(selectIsInStock);
  const personalisable = useSelector(selectIsPersonalisable);
  const productPrice = useSelector(selectProductPrice);
  const totalPrice = useSelector(selectTotalPrice);
  const optionsTotal = useSelector(selectSelectedOptionsTotal);
  const priceBreakdown = useSelector(selectOptionsBreakdown);

  if (!hasOptions || !inStock) {
    return null;
  }

  return { optionsTotal, personalisable, priceBreakdown, productPrice, totalPrice };
};
